// export const baseUrl = "http://192.168.1.134:8000/api/v1";
// export const baseUrl = "https://stem.gazettes.ng/api/v1";
export const baseUrl = "https://octopus-app-xyu98.ondigitalocean.app/api/v1";

// export const baseUrl = "https://gazetteapi.herokuapp.com/api/v1";
// export const searchUrl = `https://stem.gazettes.ng/api/v1/search`;
export const searchUrl = `https://octopus-app-xyu98.ondigitalocean.app/api/v1/search`;
